





















import Sign from '@/servers/modules/signinsignup';
/* 导入 6 个模块内容 */
import MyDialog from '@/components/dialog/readIndex.vue'; // dialog
import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import NProgress from 'nprogress';
import MyNav from '@/components/nav/Index.vue'; // 骨架结构顶部
import SwitchNav from '@/components/nav/SwitchIndex.vue'; // nav
import {
  Button, Message, Loading, Tabs, TabPane,
} from 'element-ui';
import Vocabulary from '@/servers/modules/vocabulary/vocabulary'; // server
import InputCoursesPassword from '@/views/openNewCourses/inputCoursesPassword.vue';
import myMaterial from './myMaterial.vue';
import changePassword from './changePassword.vue';
import openNewCourse from './openNewCourse.vue';
import curriculum from './curriculum.vue';
import messageCenter from './messageCenter.vue';
import helpAndFeedback from './helpAndFeedback.vue';
/* 导入 弹窗 */
/* 导入 完毕 */
    @Component({
      components: {
        MyNav,
        Button,
        MyDialog,
        Tabs,
        TabPane,
        /* 我的其他组件内容 */
        myMaterial,
        changePassword,
        openNewCourse,
        curriculum,
        messageCenter,
        helpAndFeedback,
        SwitchNav,
        InputCoursesPassword,
      },
    })
export default class extends Vue {
        @Getter public skeleton: any;

        @Mutation public setSkeletonDescribe;

        @Mutation public openDialog;

        @Mutation public closeDialog;

        // 左侧菜单栏
        @Getter public scaleCommonIndex: any;

        @Getter public navData: any;

        private title: any = '';

        isSwitch = false

        private async getStudentInfo() {
          const data = {
            refId: window.LS.get('basicData').courseId,
            userId: window.LS.get('basicData').userID,
          };
          return await Vocabulary.newGetStudentInfo(data);
        }

        private created() {

          if (this.$route.query.switch) {
            this.isSwitch = true;
          } else {
            this.isSwitch = false;
          }


          // NProgress.start();
          // 判断当前模块是否为 课程 不为课程不显示 课程设置
          if (window.LS.get('basicData').modelType != '/vocabulary') {
            this.buttons[2].show = false;
          } else {
            this.getStudentInfo().then((res: any) => {
              window.LS.set('vteData', res.data.data);
            });
          }
          this.setSkeletonDescribe(false);
          //     NProgress.done();
          this.title = '';
        }

        /* 按钮 - 相关的变量及参数 */
        private operat:any = '0';

        private buttons :any = [
          { name: '我的资料', show: true, component: 'myMaterial' },
          { name: '修改密码', show: true, component: 'changePassword' },
          // {name:'开通新课程',show:true,component:'openNewCourse'},
          { name: '课程设置', show: true, component: 'curriculum' },
          // {name:'消息中心',show:true,component:'messageCenter'},
          // {name:'帮助与反馈',show:true,component:'helpAndFeedback'}
        ];


        /* 退出登录及 tab 切换事件 */
        private operation(tab:string|number, event:any) {

        }

        private back() {
          this.$router.go(-1);
        }

        // 开通新课程
        openNewCourses() {
          this.$refs.inputCoursesPassword.changView();
        }

        changeCourseData() {
          // this.init();
        }

        // 点击菜单定位相应锚点
        barGoTop(index: number) {
          if (this.isSwitch) {
            this.$router.push({
              name: 'switchCourses',
              query: {
                index,
              },
            });
          } else {
            this.$router.go(-1);
          }
        }
}
